import Link from 'components/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { Box, Flex, Container } from 'components/Grid';
import { Ul, Li } from 'components/List';
import H2 from 'components/H2';
import css from '@styled-system/css';

const Footer = ({ siteMap }) => (
	<Flex bg="client.fontColor" color="white">
		<Container px={[3]}>
			<Flex
				justifyContent="space-between"
				css={css({
					'a:hover': {
						color: 'client.accentDark'
					}
				})}
			>
				<Box width={[1, 1, 2 / 4]} pb={[4, 0]}>
					<H2
						fontSize={['h3', 'h2']}
						lineHeight="1.4"
						css={css({
							'&:hover a': {
								color: 'client.accentDark'
							}
						})}
					>
						Du hittar oss på Mölndalsvägen 40 i Göteborg och når oss på{' '}
						<Link external cursor="pointerWhite" to="mailto:hej@sultan.se">
							hej@sultan.se
						</Link>
					</H2>
				</Box>
				<Box width={[1, 1, 1 / 3]}>
					<Ul textAlign={['left', 'right']} margin={0}>
						<Li bold fontSize={['p', 'pLarge']}>
							Sultan & Sultan
						</Li>
						{siteMap.map((item, key) => (
							<Link
								color="white"
								cursor="pointerWhite"
								className="WhiteCursor"
								key={key}
								to={item.to}
							>
								<div
									css={css({
										':hover li': {
											color: 'client.accentDark'
										}
									})}
								>
									<Li mb={0} lineHeight="1.6" fontSize={['p', 'pLarge']}>
										{item.text}
									</Li>
								</div>
							</Link>
						))}
						<Link
							to="/cookies"
							color="white"
							css={css({
								fontSize: '16px'
							})}
							mt={4}
							display="block"
						>
							Om personuppgifter och kakor
						</Link>
					</Ul>
				</Box>
			</Flex>
		</Container>
	</Flex>
);

Footer.propTypes = {
	siteMap: PropTypes.array
};

Footer.defaultProps = {};

export default Footer;
